import React from 'react';
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";

export default class TransactionDealer extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	render() {

		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, onSelectUpdate, onTextUpdate} = this.props;

		return <div>
			<div className={'form-group'}>
				<div className="row">
					<div className="col-4">
						<span className="input-label">Location</span>
					</div>
					<div className="col-8 d-flex">
						<div className={'flex-grow-1'}>
							<Framework.Elements.Select
								shouldLoad={shouldLoad}
								property={properties.internal}
								value={object.internal}
								binary_id={object.internal_binary_id}
								error={object.internal_error}
								object={object.locations_related_by_internal}
								update={onSelectUpdate}
								text={'name_display|name'}
								nullable={false}
							/>
						</div>
					</div>
				</div>
			</div>
			<p style={{
				color: "gray",
				padding: "0 4px",
				marginBottom: "19px",
				fontSize: "11px",
				lineHeight: '12px'
			}}>
				The dealer name and FFL are stored with the transaction to
				preserve past Bound Book records in the event the dealer's name
				or FFL number changes.
			</p>
			<div className="form-group">
				<Framework.Elements.TextField
					label={"Dealer Name"}
					property={properties.dealer_name_company}
					value={object.dealer_name_company}
					error={object.dealer_name_company_error}
					update={onTextUpdate}
				/>
			</div>
			<div className="form-group">
				<Framework.Elements.TextField
					label={"Dealer FFL"}
					property={properties.dealer_ffl}
					value={object.dealer_ffl}
					error={object.dealer_ffl_error}
					update={onTextUpdate}
				/>
			</div>
		</div>

	}
}

